import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Button from '@atoms/Button/Button';
import Config from '@config';

export const StyledAnimationWrapper = styled.div<{ $show: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  max-width: 0;
  transition: max-width ease ${variables.animation.layout};
  overflow: hidden;

  // Take up full height
  height: 100dvh;

  background-color: ${variables.colors.white};
  display: flex;
  flex-direction: column;

  z-index: ${variables.zIndex.mobileMenu};

  ${(props) =>
    props.$show &&
    css`
      max-width: 100vw;
    `}

  // Take up full width below tablet
  width: 100vw;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: ${rem(420)};
  }
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: ${rem(20)};
  right: ${rem(20)};
  z-index: 1;
`;
